/**
 * Lectura única de la PÓLIZA (mig 0504): el estado por archivo que trae la fila de Files
 * (`policy_reading`) y `GET /api/claims/:id/policy-readings`. Hermana de `estimateReading.ts`.
 */
export type SemaforoPoliza = 'green' | 'yellow' | 'red';

export type ResumenLecturaPoliza = {
  id: string;
  claim_file_id: string | null;
  pr_policy_id: string | null;
  status: 'queued' | 'reading' | 'done' | 'failed';
  semaforo: SemaforoPoliza | null;
  form_count: number | null;
  finding_count: number | null;
  scanned: boolean | null;
  rescue_model: string | null;
  model: string | null;
  via: string | null;
  latency_ms: number | null;
  tokens_in: number | null;
  tokens_out: number | null;
  read_at: string | null;
  started_at: string | null;
  error: string | null;
  copied: boolean;
  reader_version: number;
  carrier: string | null;
  policy_number: string | null;
  policy_form: string | null;
  period_end: string | null;
};

/** ¿Está en cola o leyéndose? (el chip gira y hay que seguir preguntando). */
export function lecturaPolizaEnCurso(r: ResumenLecturaPoliza | null | undefined): boolean {
  return r?.status === 'queued' || r?.status === 'reading';
}

/** Los tipos de archivo que se leen como póliza. */
export const POLICY_TYPES = ['policy'];
